import { createFileRoute } from '@tanstack/react-router';

import {
  loadSimulationMessages,
  loadSimulationOffersHubScreens,
  simulationInssPayrollScreen,
} from '@/modules/simulation/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Consignado INSS no caminho do legado com o rótulo padrão (`router.tsx:1173-1181`, só com
// `ENABLE_NEW_SIMULATION === 1`): a flag e a permissão vão no manifesto. Arquivo leve (JS inicial).
export const Route = createFileRoute('/_app/ccb/contratar/consignado-inss/')({
  staticData: { screen: simulationInssPayrollScreen },
  loader: () => loadSimulationMessages(),
  component: lazyScreen(loadSimulationOffersHubScreens, 'InssPayrollHubRouteScreen'),
});
